import React from 'react';
import SamPointSelector from '../../../components/SamPointSelector';
import StepActions from './StepActions';
import StepShell from './StepShell';
import { pageImage } from './wizardUtils';

// Review of the scale figure's contour, the scale counterpart of the main
// figure's "Contours" step. `onUpdateScaleContour(scaleId, points)` is owned
// by the edit page (GraphQL) and must resolve to the updated contour.
export default function ShowScaleContoursStep({
  resource,
  onUpdateScaleContour,
  onNext,
  onCancel
}) {
  const scale = resource?.scale;
  const image = pageImage(resource);

  if (!scale) {
    return (
      <StepShell>
        <h3>Scale Contour</h3>
        <div className="alert">No scale figure detected.</div>
        <StepActions onNext={onNext} onCancel={onCancel} />
      </StepShell>
    );
  }

  if (!image) {
    return (
      <StepShell>
        <h3>Scale Contour</h3>
        <div className="alert alert-danger">No page image found.</div>
        <StepActions onCancel={onCancel} />
      </StepShell>
    );
  }

  return (
    <StepShell>
      <h3>Scale Contour</h3>
      <div className="alert alert-primary">Verify that the scale contour is included.</div>
      <div className="data-step-layout">
        <SamPointSelector
          figure={scale}
          image={image}
          onPoints={(points) => onUpdateScaleContour(scale.id, points)}
        />
        <div className="d-flex align-items-center">
          <StepActions onNext={onNext} onCancel={onCancel} className="form-actions" />
        </div>
      </div>
    </StepShell>
  );
}
